// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../../css-loader@6.8.1_webpack@5.87.0_webpack-cli@5.1.4_/node_modules/css-loader/dist/cjs.js!../../../../../postcss-loader@7.3.3_postcss@8.4.35_typescript@4.9.3_webpack@5.87.0_webpack-cli@5.1.4_/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-7.use[2]!./vue3-pagination.css");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../../../../../vue-style-loader@4.1.3/node_modules/vue-style-loader/lib/addStylesClient.js").default
var update = add("5fe519fb", content, true, {});